import styled from "styled-components";
import { position } from "styled-system";

import Box from "../../layout/boxes/Box/Box";
import { StyledProgressLoaderProps } from "./ProgressLoader.types";

export const StyledProgressLoader = styled(Box)<StyledProgressLoaderProps>`
	${({ viewport, theme }) => {
		const loaderSize = viewport.greaterThan.lg ? "xxxl" : "xxl";
		const size = theme.space[loaderSize];

		return {
			width: size,
			height: size,
		};
	}}
	${position}
`;
